export default {
  title: 'Device Assignment',
};
